import { Hooks } from "ky";
import { PUBLIC_AUTH_API_PATHS } from "../../utils/authRouteConstants";
import { tokenStorage } from "../../utils/tokenStorage";
import { attemptSilentRefresh, isTokenExpiringSoon } from "../../utils/tokenRefresh";

/**
 * Ky hooks that add Authorization header to requests.
 * Proactively refreshes the access token when it is within 2 minutes of expiry,
 * so most requests never hit a 401. The reactive fallback lives in apiService.ts.
 */
export const withAuthHooks: Hooks = {
  beforeRequest: [
    async function (request) {
      const url = new URL(request.url);
      const pathname = url.pathname;
      if (PUBLIC_AUTH_API_PATHS.some((path) => pathname.includes(path))) {
        return;
      }

      // Proactively refresh if the access token is about to expire
      if (isTokenExpiringSoon()) {
        await attemptSilentRefresh();
      }

      const accessToken = tokenStorage.getAccessToken();
      if (accessToken) {
        request.headers.set("Authorization", `Bearer ${accessToken}`);
      }
    },
  ],
};
